var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { fill: "#018489", fillRule: "evenodd", d: "M11.89 4.11c.292.294.292.769 0 1.062L9.06 8l2.83 2.828c.292.293.292.768 0 1.061-.294.293-.769.293-1.062 0L8 9.061l-2.828 2.828c-.293.293-.768.293-1.061 0-.293-.293-.293-.768 0-1.06L6.939 8 4.111 5.172c-.293-.293-.293-.768 0-1.061.293-.293.768-.293 1.06 0L8 6.939l2.828-2.828c.293-.293.768-.293 1.061 0z" })
  );
});